"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getForceSetGateForTestingEnv = exports.getFeature = exports.determineGateValueWithSeed = exports.determineGateVariantIndex = exports.determineGateValueFromExposure = exports.determineGateValueFromSeedOrExposure = exports.determineGateValueShared = exports.clusterCheck = exports.isWhitelisted = exports.isBlacklisted = void 0;
const env_1 = require("gather-env-config/dist/src/public/env");
const MAX_HASH = 4294967295;
function hash(str) {
    let hash = 5381, i = str.length;
    while (i) {
        hash = (hash * 33) ^ str.charCodeAt(--i);
    }
    return hash >>> 0;
}
const isBlacklisted = (feature, { userId, spaceId }) => (userId && feature.blacklist?.includes(userId)) ||
    (spaceId && feature.blacklist?.includes(spaceId));
exports.isBlacklisted = isBlacklisted;
const isWhitelisted = (feature, { userId, spaceId }) => (userId && feature.whitelist?.includes(userId)) ||
    (spaceId && feature.whitelist?.includes(spaceId));
exports.isWhitelisted = isWhitelisted;
const clusterCheck = (feature, { clusterDomain }) => clusterDomain && (feature?.exposureByCluster?.[clusterDomain] || 0) > Math.random();
exports.clusterCheck = clusterCheck;
const determineGateValueShared = (featName, feature, { userId, spaceId, clusterDomain, spaceCreationDate, }, customChecks) => {
    if ((0, exports.isBlacklisted)(feature, { userId, spaceId }))
        return false;
    if ((0, exports.isWhitelisted)(feature, { userId, spaceId }))
        return true;
    if ((0, exports.clusterCheck)(feature, { clusterDomain }))
        return true;
    if (feature.onlyEnableIfSpaceCreatedAfterDate &&
        (!spaceCreationDate || feature.onlyEnableIfSpaceCreatedAfterDate > spaceCreationDate)) {
        return false;
    }
    if (feature.onlyEnableIfSpaceCreatedBeforeDate &&
        spaceCreationDate &&
        feature.onlyEnableIfSpaceCreatedBeforeDate <= spaceCreationDate) {
        return false;
    }
    if (customChecks) {
        const checks = customChecks();
        if (checks.matched)
            return checks.result;
    }
    return (0, exports.determineGateValueFromSeedOrExposure)(featName, feature, { userId, spaceId });
};
exports.determineGateValueShared = determineGateValueShared;
const determineGateValueFromSeedOrExposure = (featName, feature, { userId, spaceId }) => {
    if (feature.seed !== undefined)
        return (0, exports.determineGateValueWithSeed)(feature, { userId, spaceId });
    return (0, exports.determineGateValueFromExposure)(featName, feature.exposure, feature.space, {
        userId,
        spaceId,
    });
};
exports.determineGateValueFromSeedOrExposure = determineGateValueFromSeedOrExposure;
const determineGateValueFromExposure = (name, exposure, isSpaceGate, { userId, spaceId }) => {
    const objHash = isSpaceGate
        ? spaceId
            ? hash(spaceId + name)
            : null
        : userId
            ? hash(userId + name)
            : null;
    if (objHash === null)
        return false;
    return objHash < MAX_HASH * exposure;
};
exports.determineGateValueFromExposure = determineGateValueFromExposure;
const determineGateVariantIndex = (name, numberOfVariants, uniqueGatePropId) => {
    const objHash = hash(`${uniqueGatePropId}${name}`);
    if (objHash === MAX_HASH)
        return numberOfVariants - 1;
    return Math.floor((objHash / MAX_HASH) * numberOfVariants);
};
exports.determineGateVariantIndex = determineGateVariantIndex;
const determineGateValueWithSeed = (feature, { userId, spaceId }) => {
    const objHash = feature.space ? (spaceId ? hash(spaceId) : null) : userId ? hash(userId) : null;
    if (objHash === null)
        return false;
    const selection = feature.exposure * feature.seed;
    const quot = Math.floor(selection);
    const remain = selection - quot;
    if (feature.seed !== undefined) {
        return (objHash % feature.seed < quot ||
            (objHash % feature.seed === quot && objHash < MAX_HASH * remain));
    }
    else {
        return false;
    }
};
exports.determineGateValueWithSeed = determineGateValueWithSeed;
function getFeature(FEATURES, featureName) {
    const feature = FEATURES[featureName];
    return feature;
}
exports.getFeature = getFeature;
const getForceSetGateForTestingEnv = (exposure) => (0, env_1.switchEnv)({
    prod: () => undefined,
    staging: () => undefined,
    dev: () => undefined,
    local: () => undefined,
    test: () => exposure === 1,
});
exports.getForceSetGateForTestingEnv = getForceSetGateForTestingEnv;
//# sourceMappingURL=gate.js.map